import React from 'react';
import { StyleBreadcrumb, StyleBreadItem } from './styled';

export interface NavItem {
  key: string;
  label: string;
  filter?: {
    value: string;
    key: string;
    type: 'filter' | 'metricFilter'
  }
}

interface Props {
  data: NavItem[];
  onClick: (item: NavItem) => void;
}

const BreadcrumbItem = ({ item, onClick}: { item: NavItem; onClick: (e: React.MouseEvent<HTMLElement>) => void}) => {
  return (
      <StyleBreadItem onClick={onClick}>
        <div title={item.label}>{item.label}</div>
        <span>/</span>
      </StyleBreadItem>
    )
}


const Breadcrumb = ({ data, onClick }: Props) => {
  const handleClickFn = (item) => (e) => {
    e.preventDefault();
    onClick(item);
  }

  return (
    <StyleBreadcrumb>
      {
        data.map((item) => (
            <BreadcrumbItem key={item.key} item={item} onClick={handleClickFn(item)} />
        ))
      }
    </StyleBreadcrumb>
  );
}

export default Breadcrumb;
